var _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFluentEmojiFerrisWheel(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 30,
    height: 31,
    viewBox: "0 0 30 31",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "fluent-emoji:ferris-wheel"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2",
    filter: "url(#filter0_i_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint0_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint1_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint2_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint3_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint4_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint5_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint6_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_8",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint7_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_9",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint8_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_10",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint9_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_11",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint10_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_12",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.84695 27.6428C7.98084 27.6428 8.11195 27.6047 8.22488 27.5328C8.33781 27.4608 8.42787 27.3582 8.48445 27.2368L14.5435 14.2122L15.0873 14.4653L15.6245 14.2159L21.6816 27.2368C21.7382 27.3582 21.8283 27.4608 21.9412 27.5328C22.0541 27.6047 22.1853 27.6428 22.3191 27.6428H24.916C25.0403 27.6428 25.1596 27.6922 25.2475 27.7801C25.3354 27.868 25.3848 27.9872 25.3848 28.1115C25.3848 28.2359 25.3354 28.3551 25.2475 28.443C25.1596 28.5309 25.0403 28.5803 24.916 28.5803H5.22852C5.1042 28.5803 4.98497 28.5309 4.89706 28.443C4.80915 28.3551 4.75977 28.2359 4.75977 28.1115C4.75977 27.9872 4.80915 27.868 4.89706 27.7801C4.98497 27.6922 5.1042 27.6428 5.22852 27.6428H7.84602H7.84695ZM9.47445 27.1093C9.44762 27.1665 9.43565 27.2295 9.43965 27.2925C9.44366 27.3555 9.4635 27.4165 9.49734 27.4698C9.53119 27.5231 9.57794 27.5669 9.63327 27.5973C9.68859 27.6278 9.7507 27.6437 9.81383 27.6437H20.3513C20.4146 27.644 20.477 27.6283 20.5325 27.598C20.5881 27.5677 20.6351 27.5239 20.6692 27.4706C20.7032 27.4172 20.7233 27.3561 20.7273 27.293C20.7314 27.2298 20.7195 27.1666 20.6926 27.1093L15.0835 15.0522L9.47445 27.1093Z",
    fill: "url(#paint11_linear_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_3",
    filter: "url(#filter1_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_13",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "#FFCD52"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_14",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint12_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_15",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint13_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_16",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint14_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_17",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint15_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_18",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint16_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_19",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint17_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_20",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint18_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_21",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint19_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_22",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.0723 5.1792C12.8345 5.1792 10.6884 6.06815 9.10605 7.65049C7.52371 9.23282 6.63477 11.3789 6.63477 13.6167C6.63477 15.8545 7.52371 18.0006 9.10605 19.5829C10.6884 21.1653 12.8345 22.0542 15.0723 22.0542C17.31 22.0542 19.4561 21.1653 21.0385 19.5829C22.6208 18.0006 23.5098 15.8545 23.5098 13.6167C23.5098 11.3789 22.6208 9.23282 21.0385 7.65049C19.4561 6.06815 17.31 5.1792 15.0723 5.1792ZM5.69727 13.6167C5.69727 8.43889 9.89445 4.2417 15.0723 4.2417C20.2501 4.2417 24.4473 8.43889 24.4473 13.6167C24.4473 18.7945 20.2501 22.9917 15.0723 22.9917C9.89445 22.9917 5.69727 18.7945 5.69727 13.6167Z",
    fill: "url(#paint20_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_23",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.541 5.44653V13.7378H14.6035V5.44653H15.541Z",
    fill: "#9069BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_24",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.541 5.44653V13.7378H14.6035V5.44653H15.541Z",
    fill: "url(#paint21_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_25",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.541 21.9158V13.6245H14.6035V21.9158H15.541Z",
    fill: "url(#paint22_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_26",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.541 21.9158V13.6245H14.6035V21.9158H15.541Z",
    fill: "url(#paint23_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_27",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.541 21.9158V13.6245H14.6035V21.9158H15.541Z",
    fill: "url(#paint24_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_28",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35031 7.23242L15.2134 13.0946L14.5506 13.7574L8.6875 7.89523L9.35031 7.23242Z",
    fill: "#9069BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_29",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M9.35031 7.23242L15.2134 13.0946L14.5506 13.7574L8.6875 7.89523L9.35031 7.23242Z",
    fill: "url(#paint25_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_30",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.663 7.23242L14.8008 13.0946L15.4636 13.7574L21.3258 7.89523L20.663 7.23242Z",
    fill: "#8D60C4"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_31",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.663 7.23242L14.8008 13.0946L15.4636 13.7574L21.3258 7.89523L20.663 7.23242Z",
    fill: "url(#paint26_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_32",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M20.663 7.23242L14.8008 13.0946L15.4636 13.7574L21.3258 7.89523L20.663 7.23242Z",
    fill: "url(#paint27_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_33",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64258 20.2583L14.7451 13.1558L15.4079 13.8186L8.30539 20.9211L7.64258 20.2583Z",
    fill: "#7A4FAC"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_34",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64258 20.2583L14.7451 13.1558L15.4079 13.8186L8.30539 20.9211L7.64258 20.2583Z",
    fill: "url(#paint28_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_35",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.64258 20.2583L14.7451 13.1558L15.4079 13.8186L8.30539 20.9211L7.64258 20.2583Z",
    fill: "url(#paint29_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_36",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3513 20.2583L15.2487 13.1558L14.5859 13.8186L21.6884 20.9211L22.3513 20.2583Z",
    fill: "#814DC5"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_37",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M22.3513 20.2583L15.2487 13.1558L14.5859 13.8186L21.6884 20.9211L22.3513 20.2583Z",
    fill: "url(#paint30_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_38",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72266 13.0525H15.1305V13.99H5.72266V13.0525Z",
    fill: "#9069BB"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_39",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72266 13.0525H15.1305V13.99H5.72266V13.0525Z",
    fill: "url(#paint31_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_40",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.72266 13.0525H15.1305V13.99H5.72266V13.0525Z",
    fill: "url(#paint32_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_41",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2896 13.0525H14.8809V13.99H24.2896V13.0525Z",
    fill: "#8B50D3"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_42",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2896 13.0525H14.8809V13.99H24.2896V13.0525Z",
    fill: "url(#paint33_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_43",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.2896 13.0525H14.8809V13.99H24.2896V13.0525Z",
    fill: "url(#paint34_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_4",
    filter: "url(#filter2_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_44",
    d: "M16.2851 2.42969H13.8691C13.5067 2.42969 13.2129 2.7235 13.2129 3.08594V5.50187C13.2129 5.86431 13.5067 6.15813 13.8691 6.15813H16.2851C16.6475 6.15813 16.9413 5.86431 16.9413 5.50187V3.08594C16.9413 2.7235 16.6475 2.42969 16.2851 2.42969Z",
    fill: "url(#paint35_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_45",
    d: "M16.2851 2.42969H13.8691C13.5067 2.42969 13.2129 2.7235 13.2129 3.08594V5.50187C13.2129 5.86431 13.5067 6.15813 13.8691 6.15813H16.2851C16.6475 6.15813 16.9413 5.86431 16.9413 5.50187V3.08594C16.9413 2.7235 16.6475 2.42969 16.2851 2.42969Z",
    fill: "url(#paint36_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_5",
    filter: "url(#filter3_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_46",
    d: "M16.705 3.96729C16.7672 3.96729 16.8268 3.99198 16.8707 4.03593C16.9147 4.07989 16.9394 4.1395 16.9394 4.20166V5.50197C16.9394 5.58815 16.9224 5.67349 16.8894 5.75311C16.8564 5.83273 16.8081 5.90507 16.7472 5.96601C16.6862 6.02695 16.6139 6.07529 16.5343 6.10827C16.4546 6.14125 16.3693 6.15822 16.2831 6.15822H13.8672C13.781 6.15822 13.6957 6.14125 13.6161 6.10827C13.5364 6.07529 13.4641 6.02695 13.4031 5.96601C13.3422 5.90507 13.2939 5.83273 13.2609 5.75311C13.2279 5.67349 13.2109 5.58815 13.2109 5.50197V4.20166C13.2109 4.1395 13.2356 4.07989 13.2796 4.03593C13.3235 3.99198 13.3832 3.96729 13.4453 3.96729H16.705Z",
    fill: "url(#paint37_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_47",
    d: "M16.705 3.96729C16.7672 3.96729 16.8268 3.99198 16.8707 4.03593C16.9147 4.07989 16.9394 4.1395 16.9394 4.20166V5.50197C16.9394 5.58815 16.9224 5.67349 16.8894 5.75311C16.8564 5.83273 16.8081 5.90507 16.7472 5.96601C16.6862 6.02695 16.6139 6.07529 16.5343 6.10827C16.4546 6.14125 16.3693 6.15822 16.2831 6.15822H13.8672C13.781 6.15822 13.6957 6.14125 13.6161 6.10827C13.5364 6.07529 13.4641 6.02695 13.4031 5.96601C13.3422 5.90507 13.2939 5.83273 13.2609 5.75311C13.2279 5.67349 13.2109 5.58815 13.2109 5.50197V4.20166C13.2109 4.1395 13.2356 4.07989 13.2796 4.03593C13.3235 3.99198 13.3832 3.96729 13.4453 3.96729H16.705Z",
    fill: "url(#paint38_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_6",
    filter: "url(#filter4_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_48",
    d: "M9.69328 5.15771H7.27734C6.91491 5.15771 6.62109 5.45153 6.62109 5.81397V8.2299C6.62109 8.59234 6.91491 8.88615 7.27734 8.88615H9.69328C10.0557 8.88615 10.3495 8.59234 10.3495 8.2299V5.81397C10.3495 5.45153 10.0557 5.15771 9.69328 5.15771Z",
    fill: "url(#paint39_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_49",
    d: "M9.69328 5.15771H7.27734C6.91491 5.15771 6.62109 5.45153 6.62109 5.81397V8.2299C6.62109 8.59234 6.91491 8.88615 7.27734 8.88615H9.69328C10.0557 8.88615 10.3495 8.59234 10.3495 8.2299V5.81397C10.3495 5.45153 10.0557 5.15771 9.69328 5.15771Z",
    fill: "url(#paint40_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    filter: "url(#filter5_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_50",
    d: "M10.1152 6.69629C10.1773 6.69629 10.2369 6.72098 10.2809 6.76494C10.3248 6.80889 10.3495 6.8685 10.3495 6.93066V8.2291C10.3495 8.40315 10.2804 8.57007 10.1573 8.69314C10.0342 8.81621 9.86733 8.88535 9.69328 8.88535H7.27734C7.1033 8.88535 6.93638 8.81621 6.81331 8.69314C6.69023 8.57007 6.62109 8.40315 6.62109 8.2291V6.93066C6.62109 6.8685 6.64579 6.80889 6.68974 6.76494C6.73369 6.72098 6.79331 6.69629 6.85547 6.69629H10.1152Z",
    fill: "url(#paint41_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_51",
    d: "M10.1152 6.69629C10.1773 6.69629 10.2369 6.72098 10.2809 6.76494C10.3248 6.80889 10.3495 6.8685 10.3495 6.93066V8.2291C10.3495 8.40315 10.2804 8.57007 10.1573 8.69314C10.0342 8.81621 9.86733 8.88535 9.69328 8.88535H7.27734C7.1033 8.88535 6.93638 8.81621 6.81331 8.69314C6.69023 8.57007 6.62109 8.40315 6.62109 8.2291V6.93066C6.62109 6.8685 6.64579 6.80889 6.68974 6.76494C6.73369 6.72098 6.79331 6.69629 6.85547 6.69629H10.1152Z",
    fill: "url(#paint42_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_8",
    filter: "url(#filter6_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_52",
    d: "M6.95305 11.7607H4.53711C4.17467 11.7607 3.88086 12.0546 3.88086 12.417V14.8329C3.88086 15.1954 4.17467 15.4892 4.53711 15.4892H6.95305C7.31548 15.4892 7.6093 15.1954 7.6093 14.8329V12.417C7.6093 12.0546 7.31548 11.7607 6.95305 11.7607Z",
    fill: "url(#paint43_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_53",
    d: "M6.95305 11.7607H4.53711C4.17467 11.7607 3.88086 12.0546 3.88086 12.417V14.8329C3.88086 15.1954 4.17467 15.4892 4.53711 15.4892H6.95305C7.31548 15.4892 7.6093 15.1954 7.6093 14.8329V12.417C7.6093 12.0546 7.31548 11.7607 6.95305 11.7607Z",
    fill: "url(#paint44_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    filter: "url(#filter7_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_54",
    d: "M7.37492 13.2981C7.4057 13.2981 7.43618 13.3042 7.46461 13.3159C7.49305 13.3277 7.51889 13.345 7.54065 13.3667C7.56241 13.3885 7.57968 13.4143 7.59146 13.4428C7.60323 13.4712 7.6093 13.5017 7.6093 13.5325V14.8318C7.6093 15.0059 7.54016 15.1728 7.41709 15.2959C7.29402 15.419 7.1271 15.4881 6.95305 15.4881H4.53711C4.36306 15.4881 4.19614 15.419 4.07307 15.2959C3.95 15.1728 3.88086 15.0059 3.88086 14.8318V13.5325C3.88086 13.4703 3.90555 13.4107 3.94951 13.3667C3.99346 13.3228 4.05307 13.2981 4.11523 13.2981H7.37492Z",
    fill: "url(#paint45_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_55",
    d: "M7.37492 13.2981C7.4057 13.2981 7.43618 13.3042 7.46461 13.3159C7.49305 13.3277 7.51889 13.345 7.54065 13.3667C7.56241 13.3885 7.57968 13.4143 7.59146 13.4428C7.60323 13.4712 7.6093 13.5017 7.6093 13.5325V14.8318C7.6093 15.0059 7.54016 15.1728 7.41709 15.2959C7.29402 15.419 7.1271 15.4881 6.95305 15.4881H4.53711C4.36306 15.4881 4.19614 15.419 4.07307 15.2959C3.95 15.1728 3.88086 15.0059 3.88086 14.8318V13.5325C3.88086 13.4703 3.90555 13.4107 3.94951 13.3667C3.99346 13.3228 4.05307 13.2981 4.11523 13.2981H7.37492Z",
    fill: "url(#paint46_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_10",
    filter: "url(#filter8_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_56",
    d: "M9.69328 18.3633H7.27734C6.91491 18.3633 6.62109 18.6571 6.62109 19.0195V21.4355C6.62109 21.7979 6.91491 22.0917 7.27734 22.0917H9.69328C10.0557 22.0917 10.3495 21.7979 10.3495 21.4355V19.0195C10.3495 18.6571 10.0557 18.3633 9.69328 18.3633Z",
    fill: "url(#paint47_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_57",
    d: "M9.69328 18.3633H7.27734C6.91491 18.3633 6.62109 18.6571 6.62109 19.0195V21.4355C6.62109 21.7979 6.91491 22.0917 7.27734 22.0917H9.69328C10.0557 22.0917 10.3495 21.7979 10.3495 21.4355V19.0195C10.3495 18.6571 10.0557 18.3633 9.69328 18.3633Z",
    fill: "url(#paint48_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_11",
    filter: "url(#filter9_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_58",
    d: "M10.1152 19.9018C10.1773 19.9018 10.2369 19.9265 10.2809 19.9705C10.3248 20.0144 10.3495 20.074 10.3495 20.1362V21.4346C10.3495 21.6087 10.2804 21.7756 10.1573 21.8987C10.0342 22.0217 9.86733 22.0909 9.69328 22.0909H7.27734C7.19116 22.0909 7.10583 22.0739 7.02621 22.0409C6.94659 22.0079 6.87424 21.9596 6.81331 21.8987C6.75237 21.8377 6.70403 21.7654 6.67105 21.6858C6.63807 21.6061 6.62109 21.5208 6.62109 21.4346V20.1353C6.62109 20.0731 6.64579 20.0135 6.68974 19.9695C6.73369 19.9256 6.79331 19.9009 6.85547 19.9009H10.1152V19.9018Z",
    fill: "url(#paint49_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_59",
    d: "M10.1152 19.9018C10.1773 19.9018 10.2369 19.9265 10.2809 19.9705C10.3248 20.0144 10.3495 20.074 10.3495 20.1362V21.4346C10.3495 21.6087 10.2804 21.7756 10.1573 21.8987C10.0342 22.0217 9.86733 22.0909 9.69328 22.0909H7.27734C7.19116 22.0909 7.10583 22.0739 7.02621 22.0409C6.94659 22.0079 6.87424 21.9596 6.81331 21.8987C6.75237 21.8377 6.70403 21.7654 6.67105 21.6858C6.63807 21.6061 6.62109 21.5208 6.62109 21.4346V20.1353C6.62109 20.0731 6.64579 20.0135 6.68974 19.9695C6.73369 19.9256 6.79331 19.9009 6.85547 19.9009H10.1152V19.9018Z",
    fill: "url(#paint50_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_12",
    filter: "url(#filter10_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_60",
    d: "M16.2812 21.0767H13.8652C13.5028 21.0767 13.209 21.3705 13.209 21.7329V24.1488C13.209 24.5113 13.5028 24.8051 13.8652 24.8051H16.2812C16.6436 24.8051 16.9374 24.5113 16.9374 24.1488V21.7329C16.9374 21.3705 16.6436 21.0767 16.2812 21.0767Z",
    fill: "url(#paint51_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_61",
    d: "M16.2812 21.0767H13.8652C13.5028 21.0767 13.209 21.3705 13.209 21.7329V24.1488C13.209 24.5113 13.5028 24.8051 13.8652 24.8051H16.2812C16.6436 24.8051 16.9374 24.5113 16.9374 24.1488V21.7329C16.9374 21.3705 16.6436 21.0767 16.2812 21.0767Z",
    fill: "url(#paint52_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_13",
    filter: "url(#filter11_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_62",
    d: "M16.7021 22.615C16.7643 22.615 16.8239 22.6397 16.8678 22.6836C16.9118 22.7276 16.9365 22.7872 16.9365 22.8494V24.1487C16.9365 24.3228 16.8673 24.4897 16.7443 24.6128C16.6212 24.7359 16.4543 24.805 16.2802 24.805H13.8652C13.6912 24.805 13.5243 24.7359 13.4012 24.6128C13.2781 24.4897 13.209 24.3228 13.209 24.1487V22.8494C13.209 22.7872 13.2337 22.7276 13.2776 22.6836C13.3216 22.6397 13.3812 22.615 13.4434 22.615H16.7021Z",
    fill: "url(#paint53_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_63",
    d: "M16.7021 22.615C16.7643 22.615 16.8239 22.6397 16.8678 22.6836C16.9118 22.7276 16.9365 22.7872 16.9365 22.8494V24.1487C16.9365 24.3228 16.8673 24.4897 16.7443 24.6128C16.6212 24.7359 16.4543 24.805 16.2802 24.805H13.8652C13.6912 24.805 13.5243 24.7359 13.4012 24.6128C13.2781 24.4897 13.209 24.3228 13.209 24.1487V22.8494C13.209 22.7872 13.2337 22.7276 13.2776 22.6836C13.3216 22.6397 13.3812 22.615 13.4434 22.615H16.7021Z",
    fill: "url(#paint54_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_14",
    filter: "url(#filter12_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_64",
    d: "M22.8691 18.3635H20.4531C20.0907 18.3635 19.7969 18.6573 19.7969 19.0198V21.4357C19.7969 21.7982 20.0907 22.092 20.4531 22.092H22.8691C23.2315 22.092 23.5253 21.7982 23.5253 21.4357V19.0198C23.5253 18.6573 23.2315 18.3635 22.8691 18.3635Z",
    fill: "url(#paint55_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_65",
    d: "M22.8691 18.3635H20.4531C20.0907 18.3635 19.7969 18.6573 19.7969 19.0198V21.4357C19.7969 21.7982 20.0907 22.092 20.4531 22.092H22.8691C23.2315 22.092 23.5253 21.7982 23.5253 21.4357V19.0198C23.5253 18.6573 23.2315 18.3635 22.8691 18.3635Z",
    fill: "url(#paint56_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_15",
    filter: "url(#filter13_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_66",
    d: "M23.2909 19.9018C23.3531 19.9018 23.4127 19.9265 23.4567 19.9705C23.5006 20.0144 23.5253 20.074 23.5253 20.1362V21.4346C23.5253 21.6087 23.4562 21.7756 23.3331 21.8987C23.21 22.0217 23.0431 22.0909 22.8691 22.0909H20.4531C20.2791 22.0909 20.1122 22.0217 19.9891 21.8987C19.866 21.7756 19.7969 21.6087 19.7969 21.4346V20.1353C19.7969 20.0731 19.8216 20.0135 19.8655 19.9695C19.9095 19.9256 19.9691 19.9009 20.0313 19.9009H23.2909V19.9018Z",
    fill: "url(#paint57_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_67",
    d: "M23.2909 19.9018C23.3531 19.9018 23.4127 19.9265 23.4567 19.9705C23.5006 20.0144 23.5253 20.074 23.5253 20.1362V21.4346C23.5253 21.6087 23.4562 21.7756 23.3331 21.8987C23.21 22.0217 23.0431 22.0909 22.8691 22.0909H20.4531C20.2791 22.0909 20.1122 22.0217 19.9891 21.8987C19.866 21.7756 19.7969 21.6087 19.7969 21.4346V20.1353C19.7969 20.0731 19.8216 20.0135 19.8655 19.9695C19.9095 19.9256 19.9691 19.9009 20.0313 19.9009H23.2909V19.9018Z",
    fill: "url(#paint58_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_16",
    filter: "url(#filter14_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_68",
    d: "M25.5937 11.7607H23.1777C22.8153 11.7607 22.5215 12.0546 22.5215 12.417V14.8329C22.5215 15.1954 22.8153 15.4892 23.1777 15.4892H25.5937C25.9561 15.4892 26.2499 15.1954 26.2499 14.8329V12.417C26.2499 12.0546 25.9561 11.7607 25.5937 11.7607Z",
    fill: "url(#paint59_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_69",
    d: "M25.5937 11.7607H23.1777C22.8153 11.7607 22.5215 12.0546 22.5215 12.417V14.8329C22.5215 15.1954 22.8153 15.4892 23.1777 15.4892H25.5937C25.9561 15.4892 26.2499 15.1954 26.2499 14.8329V12.417C26.2499 12.0546 25.9561 11.7607 25.5937 11.7607Z",
    fill: "url(#paint60_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_17",
    filter: "url(#filter15_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_70",
    d: "M26.0155 13.2981C26.0777 13.2981 26.1373 13.3228 26.1813 13.3667C26.2252 13.4107 26.2499 13.4703 26.2499 13.5325V14.8318C26.2499 15.0059 26.1808 15.1728 26.0577 15.2959C25.9346 15.419 25.7677 15.4881 25.5937 15.4881H23.1777C23.0037 15.4881 22.8368 15.419 22.7137 15.2959C22.5906 15.1728 22.5215 15.0059 22.5215 14.8318V13.5325C22.5215 13.4703 22.5462 13.4107 22.5901 13.3667C22.6341 13.3228 22.6937 13.2981 22.7559 13.2981H26.0155Z",
    fill: "url(#paint61_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_71",
    d: "M26.0155 13.2981C26.0777 13.2981 26.1373 13.3228 26.1813 13.3667C26.2252 13.4107 26.2499 13.4703 26.2499 13.5325V14.8318C26.2499 15.0059 26.1808 15.1728 26.0577 15.2959C25.9346 15.419 25.7677 15.4881 25.5937 15.4881H23.1777C23.0037 15.4881 22.8368 15.419 22.7137 15.2959C22.5906 15.1728 22.5215 15.0059 22.5215 14.8318V13.5325C22.5215 13.4703 22.5462 13.4107 22.5901 13.3667C22.6341 13.3228 22.6937 13.2981 22.7559 13.2981H26.0155Z",
    fill: "url(#paint62_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_18",
    filter: "url(#filter16_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_72",
    d: "M22.8769 5.16162H20.4609C20.0985 5.16162 19.8047 5.45543 19.8047 5.81787V8.23381C19.8047 8.59625 20.0985 8.89006 20.4609 8.89006H22.8769C23.2393 8.89006 23.5331 8.59625 23.5331 8.23381V5.81787C23.5331 5.45543 23.2393 5.16162 22.8769 5.16162Z",
    fill: "url(#paint63_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_73",
    d: "M22.8769 5.16162H20.4609C20.0985 5.16162 19.8047 5.45543 19.8047 5.81787V8.23381C19.8047 8.59625 20.0985 8.89006 20.4609 8.89006H22.8769C23.2393 8.89006 23.5331 8.59625 23.5331 8.23381V5.81787C23.5331 5.45543 23.2393 5.16162 22.8769 5.16162Z",
    fill: "url(#paint64_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_19",
    filter: "url(#filter17_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_74",
    d: "M23.2987 6.69922C23.3609 6.69922 23.4205 6.72391 23.4645 6.76787C23.5084 6.81182 23.5331 6.87143 23.5331 6.93359V8.23297C23.5331 8.40702 23.464 8.57394 23.3409 8.69701C23.2178 8.82008 23.0509 8.88922 22.8769 8.88922H20.4609C20.2869 8.88922 20.12 8.82008 19.9969 8.69701C19.8738 8.57394 19.8047 8.40702 19.8047 8.23297V6.93359C19.8047 6.87143 19.8294 6.81182 19.8733 6.76787C19.9173 6.72391 19.9769 6.69922 20.0391 6.69922H23.2987Z",
    fill: "url(#paint65_linear_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_75",
    d: "M23.2987 6.69922C23.3609 6.69922 23.4205 6.72391 23.4645 6.76787C23.5084 6.81182 23.5331 6.87143 23.5331 6.93359V8.23297C23.5331 8.40702 23.464 8.57394 23.3409 8.69701C23.2178 8.82008 23.0509 8.88922 22.8769 8.88922H20.4609C20.2869 8.88922 20.12 8.82008 19.9969 8.69701C19.8738 8.57394 19.8047 8.40702 19.8047 8.23297V6.93359C19.8047 6.87143 19.8294 6.81182 19.8733 6.76787C19.9173 6.72391 19.9769 6.69922 20.0391 6.69922H23.2987Z",
    fill: "url(#paint66_radial_434_3450)"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_20",
    filter: "url(#filter18_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_76",
    d: "M15.073 15.942C16.3571 15.942 17.398 14.9011 17.398 13.617C17.398 12.3329 16.3571 11.292 15.073 11.292C13.789 11.292 12.748 12.3329 12.748 13.617C12.748 14.9011 13.789 15.942 15.073 15.942Z",
    fill: "#FFC952"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_77",
    d: "M15.073 15.942C16.3571 15.942 17.398 14.9011 17.398 13.617C17.398 12.3329 16.3571 11.292 15.073 11.292C13.789 11.292 12.748 12.3329 12.748 13.617C12.748 14.9011 13.789 15.942 15.073 15.942Z",
    fill: "url(#paint67_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_21",
    filter: "url(#filter19_ii_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_78",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.072 8.03312C14.3325 8.02354 13.5986 8.16091 12.9127 8.43724C12.2268 8.71358 11.6026 9.12338 11.0763 9.64287C10.55 10.1624 10.1322 10.7812 9.84697 11.4635C9.56177 12.1457 9.41491 12.8779 9.41491 13.6173C9.41491 14.3568 9.56177 15.0889 9.84697 15.7712C10.1322 16.4535 10.55 17.0723 11.0763 17.5918C11.6026 18.1113 12.2268 18.5211 12.9127 18.7974C13.5986 19.0738 14.3325 19.2111 15.072 19.2016C16.5531 19.2016 17.9736 18.6132 19.0209 17.5658C20.0683 16.5185 20.6566 15.098 20.6566 13.6169C20.6566 12.1357 20.0683 10.7152 19.0209 9.6679C17.9736 8.62057 16.5531 8.03312 15.072 8.03312ZM8.54883 13.6159C8.54883 11.8861 9.23599 10.2272 10.4591 9.00406C11.6823 7.78091 13.3412 7.09375 15.071 7.09375C16.8008 7.09375 18.4598 7.78091 19.6829 9.00406C20.906 10.2272 21.5932 11.8861 21.5932 13.6159C21.5932 15.3457 20.906 17.0047 19.6829 18.2278C18.4598 19.451 16.8008 20.1381 15.071 20.1381C13.3412 20.1381 11.6823 19.451 10.4591 18.2278C9.23599 17.0047 8.54883 15.3457 8.54883 13.6159Z",
    fill: "#F7BD4B"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Vector_79",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.072 8.03312C14.3325 8.02354 13.5986 8.16091 12.9127 8.43724C12.2268 8.71358 11.6026 9.12338 11.0763 9.64287C10.55 10.1624 10.1322 10.7812 9.84697 11.4635C9.56177 12.1457 9.41491 12.8779 9.41491 13.6173C9.41491 14.3568 9.56177 15.0889 9.84697 15.7712C10.1322 16.4535 10.55 17.0723 11.0763 17.5918C11.6026 18.1113 12.2268 18.5211 12.9127 18.7974C13.5986 19.0738 14.3325 19.2111 15.072 19.2016C16.5531 19.2016 17.9736 18.6132 19.0209 17.5658C20.0683 16.5185 20.6566 15.098 20.6566 13.6169C20.6566 12.1357 20.0683 10.7152 19.0209 9.6679C17.9736 8.62057 16.5531 8.03312 15.072 8.03312ZM8.54883 13.6159C8.54883 11.8861 9.23599 10.2272 10.4591 9.00406C11.6823 7.78091 13.3412 7.09375 15.071 7.09375C16.8008 7.09375 18.4598 7.78091 19.6829 9.00406C20.906 10.2272 21.5932 11.8861 21.5932 13.6159C21.5932 15.3457 20.906 17.0047 19.6829 18.2278C18.4598 19.451 16.8008 20.1381 15.071 20.1381C13.3412 20.1381 11.6823 19.451 10.4591 18.2278C9.23599 17.0047 8.54883 15.3457 8.54883 13.6159Z",
    fill: "url(#paint68_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_80",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.072 8.03312C14.3325 8.02354 13.5986 8.16091 12.9127 8.43724C12.2268 8.71358 11.6026 9.12338 11.0763 9.64287C10.55 10.1624 10.1322 10.7812 9.84697 11.4635C9.56177 12.1457 9.41491 12.8779 9.41491 13.6173C9.41491 14.3568 9.56177 15.0889 9.84697 15.7712C10.1322 16.4535 10.55 17.0723 11.0763 17.5918C11.6026 18.1113 12.2268 18.5211 12.9127 18.7974C13.5986 19.0738 14.3325 19.2111 15.072 19.2016C16.5531 19.2016 17.9736 18.6132 19.0209 17.5658C20.0683 16.5185 20.6566 15.098 20.6566 13.6169C20.6566 12.1357 20.0683 10.7152 19.0209 9.6679C17.9736 8.62057 16.5531 8.03312 15.072 8.03312ZM8.54883 13.6159C8.54883 11.8861 9.23599 10.2272 10.4591 9.00406C11.6823 7.78091 13.3412 7.09375 15.071 7.09375C16.8008 7.09375 18.4598 7.78091 19.6829 9.00406C20.906 10.2272 21.5932 11.8861 21.5932 13.6159C21.5932 15.3457 20.906 17.0047 19.6829 18.2278C18.4598 19.451 16.8008 20.1381 15.071 20.1381C13.3412 20.1381 11.6823 19.451 10.4591 18.2278C9.23599 17.0047 8.54883 15.3457 8.54883 13.6159Z",
    fill: "url(#paint69_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_81",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.072 8.03312C14.3325 8.02354 13.5986 8.16091 12.9127 8.43724C12.2268 8.71358 11.6026 9.12338 11.0763 9.64287C10.55 10.1624 10.1322 10.7812 9.84697 11.4635C9.56177 12.1457 9.41491 12.8779 9.41491 13.6173C9.41491 14.3568 9.56177 15.0889 9.84697 15.7712C10.1322 16.4535 10.55 17.0723 11.0763 17.5918C11.6026 18.1113 12.2268 18.5211 12.9127 18.7974C13.5986 19.0738 14.3325 19.2111 15.072 19.2016C16.5531 19.2016 17.9736 18.6132 19.0209 17.5658C20.0683 16.5185 20.6566 15.098 20.6566 13.6169C20.6566 12.1357 20.0683 10.7152 19.0209 9.6679C17.9736 8.62057 16.5531 8.03312 15.072 8.03312ZM8.54883 13.6159C8.54883 11.8861 9.23599 10.2272 10.4591 9.00406C11.6823 7.78091 13.3412 7.09375 15.071 7.09375C16.8008 7.09375 18.4598 7.78091 19.6829 9.00406C20.906 10.2272 21.5932 11.8861 21.5932 13.6159C21.5932 15.3457 20.906 17.0047 19.6829 18.2278C18.4598 19.451 16.8008 20.1381 15.071 20.1381C13.3412 20.1381 11.6823 19.451 10.4591 18.2278C9.23599 17.0047 8.54883 15.3457 8.54883 13.6159Z",
    fill: "url(#paint70_radial_434_3450)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_22",
    filter: "url(#filter20_f_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_82",
    d: "M15.1316 19.6704C18.4748 19.6704 21.185 16.9601 21.185 13.6169C21.185 10.2737 18.4748 7.56348 15.1316 7.56348C11.7883 7.56348 9.07812 10.2737 9.07812 13.6169C9.07812 16.9601 11.7883 19.6704 15.1316 19.6704Z",
    stroke: "url(#paint71_linear_434_3450)",
    strokeWidth: 0.234375
  })), /*#__PURE__*/React.createElement("g", {
    id: "Group_23",
    filter: "url(#filter21_f_434_3450)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector_83",
    d: "M5.54492 28.0225H24.6409",
    stroke: "url(#paint72_linear_434_3450)",
    strokeWidth: 0.1875,
    strokeLinecap: "round"
  }))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_i_434_3450",
    x: 4.75977,
    y: 14.2122,
    width: 20.7656,
    height: 14.3682,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.140625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.415686 0 0 0 0 0.376471 0 0 0 0 0.431373 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter1_ii_434_3450",
    x: 5.55664,
    y: 4.10107,
    width: 19.0312,
    height: 19.0312,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.140625,
    dy: -0.140625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.843137 0 0 0 0 0.466667 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.140625,
    dy: 0.140625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 1 0 0 0 0 0.941176 0 0 0 0 0.305882 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter2_ii_434_3450",
    x: 12.7441,
    y: 2.42969,
    width: 4.66602,
    height: 3.82227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.878431 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: 0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.403922 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter3_ii_434_3450",
    x: 12.8359,
    y: 3.73291,
    width: 4.57227,
    height: 2.42529,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.521569 0 0 0 0 0.780392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.254902 0 0 0 0 0.658824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter4_ii_434_3450",
    x: 6.15234,
    y: 5.15771,
    width: 4.66602,
    height: 3.82227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.878431 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: 0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.403922 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter5_ii_434_3450",
    x: 6.24609,
    y: 6.46191,
    width: 4.57227,
    height: 2.42334,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.521569 0 0 0 0 0.780392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.254902 0 0 0 0 0.658824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter6_ii_434_3450",
    x: 3.41211,
    y: 11.7607,
    width: 4.66602,
    height: 3.82227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.878431 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: 0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.403922 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter7_ii_434_3450",
    x: 3.50586,
    y: 13.0637,
    width: 4.57227,
    height: 2.42432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.521569 0 0 0 0 0.780392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.254902 0 0 0 0 0.658824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter8_ii_434_3450",
    x: 6.15234,
    y: 18.3633,
    width: 4.66602,
    height: 3.82227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.878431 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: 0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.403922 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter9_ii_434_3450",
    x: 6.24609,
    y: 19.6665,
    width: 4.57227,
    height: 2.42432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.521569 0 0 0 0 0.780392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.254902 0 0 0 0 0.658824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter10_ii_434_3450",
    x: 12.7402,
    y: 21.0767,
    width: 4.66602,
    height: 3.82227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.898039 0 0 0 0 0.878431 0 0 0 0 0.921569 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: 0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.403922 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter11_ii_434_3450",
    x: 12.834,
    y: 22.3806,
    width: 4.57031,
    height: 2.42432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.521569 0 0 0 0 0.780392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.254902 0 0 0 0 0.658824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter12_ii_434_3450",
    x: 19.3281,
    y: 18.3635,
    width: 4.66602,
    height: 3.82227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.941176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: 0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.403922 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter13_ii_434_3450",
    x: 19.4219,
    y: 19.6665,
    width: 4.57227,
    height: 2.42432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.521569 0 0 0 0 0.780392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.254902 0 0 0 0 0.658824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter14_ii_434_3450",
    x: 22.0527,
    y: 11.7607,
    width: 4.66602,
    height: 3.82227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.941176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: 0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.403922 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter15_ii_434_3450",
    x: 22.1465,
    y: 13.0637,
    width: 4.57227,
    height: 2.42432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.521569 0 0 0 0 0.780392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.254902 0 0 0 0 0.658824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter16_ii_434_3450",
    x: 19.3359,
    y: 5.16162,
    width: 4.66602,
    height: 3.82227,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.46875
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.968627 0 0 0 0 0.941176 0 0 0 0 1 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: 0.09375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.458824 0 0 0 0 0.403922 0 0 0 0 0.486275 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter17_ii_434_3450",
    x: 19.4297,
    y: 6.46484,
    width: 4.57227,
    height: 2.42432,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.1875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.564706 0 0 0 0 0.521569 0 0 0 0 0.780392 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.46875,
    dy: -0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.411765 0 0 0 0 0.254902 0 0 0 0 0.658824 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter18_ii_434_3450",
    x: 12.748,
    y: 10.917,
    width: 5.02539,
    height: 5.25928,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.375,
    dy: -0.375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.46875
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.870588 0 0 0 0 0.498039 0 0 0 0 0.32549 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.234375,
    dy: 0.234375
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.351562
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.686275 0 0 0 0 0.529412 0 0 0 0 0.25098 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter19_ii_434_3450",
    x: 8.4082,
    y: 6.95312,
    width: 13.3262,
    height: 13.3257,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0.140625,
    dy: -0.140625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.796078 0 0 0 0 0.490196 0 0 0 0 0.309804 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "shape",
    result: "effect1_innerShadow_434_3450"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: -0.140625,
    dy: 0.140625
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.234375
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "arithmetic",
    k2: -1,
    k3: 1
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0.701961 0 0 0 0 0.537255 0 0 0 0 0.203922 0 0 0 1 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "effect1_innerShadow_434_3450",
    result: "effect2_innerShadow_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter20_f_434_3450",
    x: 8.72656,
    y: 7.21191,
    width: 12.8105,
    height: 12.8101,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.117188,
    result: "effect1_foregroundBlur_434_3450"
  })), /*#__PURE__*/React.createElement("filter", {
    id: "filter21_f_434_3450",
    x: 5.16992,
    y: 27.6475,
    width: 19.8457,
    height: 0.75,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "BackgroundImageFix",
    result: "shape"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 0.140625,
    result: "effect1_foregroundBlur_434_3450"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_434_3450",
    x1: 15.0723,
    y1: 28.0862,
    x2: 22.6304,
    y2: 28.0862,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#998EA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DFCCF3"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint1_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(18.2945 22.1097) rotate(-26.565) scale(1.04816 5.13597)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9771B1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9771B1",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint2_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.8926 15.6203) rotate(68.085) scale(4.12104 1.07339)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#816497"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#816497",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint3_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.9948 17.5834) rotate(-23.9625) scale(0.577082 3.8492)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.345,
    stopColor: "#674C77"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#674C77",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint4_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.1995 27.0897) rotate(33.2749) scale(1.12135 0.601409)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.294,
    stopColor: "#8B838E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8B838E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint5_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.4145 26.2693) rotate(153.925) scale(0.766495 2.41593)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.183,
    stopColor: "#F4EDFA"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#F4EDFA",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint6_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.3257 27.8481) rotate(164.899) scale(0.711213 0.524347)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FDF7FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FDF7FF",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint7_linear_434_3450",
    x1: 4.75977,
    y1: 28.5803,
    x2: 5.36352,
    y2: 28.5803,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.27,
    stopColor: "#7F7588"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7F7588",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint8_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.24727 27.369) scale(0.926438 0.403275)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.165,
    stopColor: "#7B777D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#7B777D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint9_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.5163 22.944) rotate(-154.699) scale(1.32612 5.13931)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9673AC"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9673AC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint10_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(14.3939 15.7283) rotate(112.674) scale(5.31546 1.22059)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#704D82"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#704D82",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint11_linear_434_3450",
    x1: 15.0723,
    y1: 28.5803,
    x2: 15.0723,
    y2: 28.1593,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A764DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A764DC",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint12_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.0606 6.23075) rotate(-151.535) scale(1.29024 0.539672)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.21,
    stopColor: "#B27F32"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B27F32",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint13_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(11.6306 6.11384) rotate(-116.906) scale(1.10059 5.01417)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.103,
    stopColor: "#DE9347"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#DE9347",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint14_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8117 4.70661) rotate(143.881) scale(2.68383 1.28435)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.072,
    stopColor: "#A6812D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A6812D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint15_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.21832 8.51562) rotate(137.684) scale(2.65456 1.86819)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.199,
    stopColor: "#CB7D3F"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#CB7D3F",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint16_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.59508 15.0342) rotate(60.7511) scale(1.25917 2.74532)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#BD6F43"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BD6F43",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint17_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.92727 18.9454) rotate(-110.323) scale(1.68705 0.918086)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.133,
    stopColor: "#B4803A"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B4803A",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint18_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.5488 22.1976) rotate(-168.147) scale(1.21238 0.956795)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#B47C2D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B47C2D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint19_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.9941 20.7323) rotate(157.094) scale(2.25813 1.20872)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.109,
    stopColor: "#B37C29"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#B37C29",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint20_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(23.6127 15.3864) rotate(136.134) scale(2.09273 0.970997)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#C1783C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#C1783C",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint21_linear_434_3450",
    x1: 14.6598,
    y1: 9.59216,
    x2: 15.2645,
    y2: 9.59216,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44324E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44324E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint22_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0723 19.6808) rotate(-90) scale(5.13445 0.495628)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8B60C0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#653E93"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint23_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0723 19.9714) rotate(90) scale(0.864262 1.21582)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.186,
    stopColor: "#4D2C5D"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4D2C5D",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint24_linear_434_3450",
    x1: 15.6066,
    y1: 18.8642,
    x2: 15.2663,
    y2: 18.8642,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#614679"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#614679",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint25_linear_434_3450",
    x1: 11.6594,
    y1: 10.7865,
    x2: 12.0869,
    y2: 10.359,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44324E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44324E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint26_linear_434_3450",
    x1: 17.7323,
    y1: 10.163,
    x2: 18.0633,
    y2: 10.4949,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.155,
    stopColor: "#513F59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513F59",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint27_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(20.318 8.72117) rotate(142.853) scale(1.21291 1.23094)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C3658",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint28_linear_434_3450",
    x1: 11.8173,
    y1: 17.3304,
    x2: 11.3888,
    y2: 16.902,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44324E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44324E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint29_linear_434_3450",
    x1: 13.6013,
    y1: 14.6904,
    x2: 12.6873,
    y2: 15.6036,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44324E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44324E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint30_linear_434_3450",
    x1: 18.7644,
    y1: 16.7342,
    x2: 18.3444,
    y2: 17.1617,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#695677"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#695677",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint31_linear_434_3450",
    x1: 10.427,
    y1: 13.9337,
    x2: 10.427,
    y2: 13.3291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44324E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44324E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint32_linear_434_3450",
    x1: 13.3567,
    y1: 13.3291,
    x2: 12.1464,
    y2: 13.3291,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#44324E"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#44324E",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint33_linear_434_3450",
    x1: 19.5852,
    y1: 13.0525,
    x2: 19.5852,
    y2: 13.8466,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#513F59"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#513F59",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint34_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.4698 13.0524) rotate(102.317) scale(1.09869 1.25238)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#4C3658"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4C3658",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint35_linear_434_3450",
    x1: 14.097,
    y1: 3.83313,
    x2: 16.0104,
    y2: 3.83313,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB2C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint36_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0766 4.29344) rotate(-90) scale(0.728391 3.07544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9893A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9893A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint37_linear_434_3450",
    x1: 13.8409,
    y1: 4.91229,
    x2: 16.6534,
    y2: 4.91229,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E66DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint38_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1266 3.96729) rotate(90) scale(1.79443 0.776372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#736AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint39_linear_434_3450",
    x1: 7.50609,
    y1: 6.56209,
    x2: 9.41953,
    y2: 6.56209,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB2C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint40_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.48484 7.02146) rotate(-90) scale(0.728391 3.07544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9893A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9893A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint41_linear_434_3450",
    x1: 7.25109,
    y1: 7.64035,
    x2: 10.0636,
    y2: 7.64035,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E66DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint42_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.53672 6.69629) rotate(90) scale(1.79443 0.776372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#736AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint43_linear_434_3450",
    x1: 4.76586,
    y1: 13.1651,
    x2: 7.6093,
    y2: 13.1651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB2C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint44_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(5.74555 13.6245) rotate(-90) scale(0.728391 3.07544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9893A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9893A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint45_linear_434_3450",
    x1: 4.51086,
    y1: 14.2431,
    x2: 7.32336,
    y2: 14.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E66DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint46_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(6.79648 13.2981) rotate(90) scale(1.79443 0.776372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#736AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint47_linear_434_3450",
    x1: 7.50609,
    y1: 19.7667,
    x2: 10.3495,
    y2: 19.7667,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB2C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint48_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(8.48484 20.227) rotate(-90) scale(0.728391 3.07544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9893A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9893A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint49_linear_434_3450",
    x1: 7.25109,
    y1: 20.8459,
    x2: 10.0636,
    y2: 20.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E66DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint50_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(9.53672 19.9018) rotate(90) scale(1.79443 0.776372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#736AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint51_linear_434_3450",
    x1: 14.093,
    y1: 22.481,
    x2: 16.9365,
    y2: 22.481,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB2C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint52_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(15.0727 22.9404) rotate(-90) scale(0.728391 3.07544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9893A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9893A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint53_linear_434_3450",
    x1: 13.838,
    y1: 23.5591,
    x2: 16.6515,
    y2: 23.5591,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E66DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint54_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(16.1237 22.615) rotate(90) scale(1.79443 0.776372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#736AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint55_linear_434_3450",
    x1: 20.6819,
    y1: 19.767,
    x2: 23.5253,
    y2: 19.767,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB2C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint56_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6606 20.2273) rotate(-90) scale(0.728391 3.07544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9893A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9893A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint57_linear_434_3450",
    x1: 20.4269,
    y1: 20.8459,
    x2: 23.2394,
    y2: 20.8459,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E66DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint58_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7125 19.9018) rotate(90) scale(1.79443 0.776372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#736AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint59_linear_434_3450",
    x1: 23.4065,
    y1: 13.1651,
    x2: 26.2499,
    y2: 13.1651,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB2C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint60_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(24.3862 13.6245) rotate(-90) scale(0.728391 3.07544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9893A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9893A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint61_linear_434_3450",
    x1: 23.1515,
    y1: 14.2431,
    x2: 25.964,
    y2: 14.2431,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E66DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint62_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(25.4371 13.2981) rotate(90) scale(1.79443 0.776372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#736AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint63_linear_434_3450",
    x1: 20.6897,
    y1: 6.56506,
    x2: 23.5331,
    y2: 6.56506,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A69EB0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#BCB2C8"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint64_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.6684 7.02537) rotate(-90) scale(0.728391 3.07544)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#9893A0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#9893A0",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint65_linear_434_3450",
    x1: 20.4347,
    y1: 7.64422,
    x2: 23.2472,
    y2: 7.64422,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8E66DB"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#796BB4"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint66_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.7194 6.69922) rotate(90) scale(1.79443 0.776372)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.184,
    stopColor: "#736AA5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#736AA5",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint67_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(13.8721 14.8732) rotate(-37.2209) scale(3.82624 4.57165)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.657,
    stopColor: "#FFEE59",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFEE59"
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint68_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(19.5259 8.69255) rotate(133.603) scale(0.849609 1.19158)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A87B2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint69_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(22.1332 13.6169) rotate(180) scale(1.20117 1.68465)"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#A87B2B"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#A87B2B",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("radialGradient", {
    id: "paint70_radial_434_3450",
    cx: 0,
    cy: 0,
    r: 1,
    gradientUnits: "userSpaceOnUse",
    gradientTransform: "translate(21.1807 11.02) rotate(149.216) scale(0.801395 2.53994)"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.156,
    stopColor: "#FFE653"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFE653",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint71_linear_434_3450",
    x1: 10.1225,
    y1: 13.6169,
    x2: 20.6984,
    y2: 13.6169,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#FFCE55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FFCE55",
    stopOpacity: 0
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint72_linear_434_3450",
    x1: "-nan",
    y1: "-nan",
    x2: "-nan",
    y2: "-nan",
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19BC8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#E8D3FF"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFluentEmojiFerrisWheel);
export default __webpack_public_path__ + "static/media/fluent-emoji_ferris-wheel.903fe010c4a147510fc22d7bb861938b.svg";
export { ForwardRef as ReactComponent };